<template>
  <div class="">
    <center-header :title="$t('member.shdz')" active="shop" :right="false" :centername="true"></center-header>
    <!-- 收货地址 -->
    <div class="add-bg">
      <div class="address">
        <a-form layout="vertical" :form="form" @submit="Address">
          <a-form-item :label="$t('member.shdz')" :required="true">
            <!-- 国家 -->
            <a-cascader :field-names="{ label: 'Name', value: 'Name', children: 'City' }" :options="district"
              placeholder="Please select" @change="onChange" v-decorator="['district',{initialValue:[fill.country,fill.province,fill.city,fill.district]},{required: true, message: $t('tips.a4')}]"/>
          </a-form-item>
          <a-form-item>
            <div class="detailed">
              <a-textarea :placeholder="$t('tips.a1')" :auto-size="{ minRows: 4, maxRows: 4 }" allowClear v-decorator="['detailed',{initialValue:fill.address,rules:[{ required: true, message:$t('tips.a1')}] }]" />
            </div>
          </a-form-item>
          <a-form-item :label="$t('member.shr')">
            <a-input v-decorator="[ 'username',{initialValue:fill.contact_name,rules:[{required: true, message: $t('tips.a2')}]}]" :placeholder="$t('tips.a2')" />
          </a-form-item>
          <a-form-item :label="$t('member.lxdh')">
            <a-input v-decorator="[ 'userphone',{initialValue:fill.contact_phone,rules:[{required: true, message: $t('tips.r4')}]}]" :placeholder="$t('tips.r4')" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit">
              {{$t('title.submit')}}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="address_list">
        <a-table :columns="columns" :data-source="data" bordered :pagination="false">
          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
              <span>
                <a :disabled="editingKey !== ''" @click="() => edit(record.key)">{{$t('member.edit')}}</a>
                <span style="padding: 0 10px;">|</span>
                <a-popconfirm v-if="data.length" :title="$t('tips.a3')" @confirm="() => onDelete(record.key)" :okText="$t('member.confirm')"
                  :cancelText="$t('member.cancel')">
                  <a :disabled="editingKey !== ''">{{$t('member.del')}}</a>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <!-- 地址展示 -->
  </div>
</template>

<script>
  import CenterHeader from './common/CenterHeader'
  import district from '../assets/district.json'
  const columns = [{
      title: '收货人',
      dataIndex: 'name',
      width: '300px',
      align: 'center',
      scopedSlots: {
        customRender: 'name'
      },
    },
    {
      title: "收货地址",
      dataIndex: 'address',
      width: '300px',
      align: 'center',
      scopedSlots: {
        customRender: 'address'
      },
    },
    {
      title: '联系电话',
      dataIndex: 'phone',
      width: '300px',
      align: 'center',
      scopedSlots: {
        customRender: 'phone'
      },
    },
    {
      title: '操作',
      width: '300px',
      align: 'center',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    },
  ];
  const data = [];
  export default {
    components: {
      CenterHeader
    },
    data() {
      return {
        data,
        columns,
        editingKey: '',
        district,
        fill:'',
        form: this.$form.createForm(this, {
          name: 'dynamic_rule'
        }),
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/download') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods: {
      onChange(value) {
        console.log(value);
      },
      init(lang) {
        this.data = []
        this.$api.dongjuapi.addressList().then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            this.data.push({
              key: res.data.data[i].id,
              name: res.data.data[i].contact_name,
              phone: res.data.data[i].contact_phone,
              address:res.data.data[i].country + res.data.data[i].province + res.data.data[i].city + res.data.data[i].district + res.data
                .data[i].address
            })
          }
        }).catch(err => {
          this.$message.error(err.data.message);
        })
      },
      Address(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              country: values.district[0],
              province: values.district[1],
              city: values.district[2],
              district: values.district[3],
              address: values.detailed,
              contact_name: values.username,
              contact_phone: values.userphone
            }
            let query = {
              id:this.fill.id,
              member_id:this.fill.member_id,
              country: values.district[0],
              province: values.district[1],
              city: values.district[2],
              district: values.district[3],
              address: values.detailed,
              contact_name: values.username,
              contact_phone: values.userphone
            }
            // 添加地址
            if(this.fill){
              this.$api.dongjuapi.addressUpdate(query).then(res=>{
                if(res.data.code==200){
                  this.init()
                  this.fill = ""
                  this.form.resetFields()
                  this.$message.success('修改成功');
                }
              }).catch(err=>{
                this.$message.error(err.data.message);
              })
            }else{
              this.$api.dongjuapi.address(params).then(res => {
                if (res.data.code == 200) {
                  this.init()
                  this.form.resetFields()
                  this.$message.success('保存成功');
                }
              }).catch(err => {
                this.$message.error(err.data.message);
              })
            }
          }
        });
      },
      // 表格操作
      edit(key) {
        this.$api.dongjuapi.addressDetails(key).then(res=>{
          this.fill = res.data.data
        }).catch(err=>{
          this.$message.error(err.data.message);
        })
      },
      onDelete(key) {
        this.$api.dongjuapi.addressDetele(key, {
          key
        }).then(res => {
          console.log(res)
          if (res.data.code == 200) {
            this.$message.success(res.data.data);
            this.init()
          }
        }).catch(err => {
          console.log(err)
        })
      },
    },
  }
</script>

<style lang="less">
  .add-bg {
    background: #fff;
    padding: 55px 0px 80px 160px;
  }

  .address {
    width: 700px;
  }

  .detailed {
    width: 500px;
    height: 100px;
  }

  .address_list {
    width: 1200px;
  }
</style>
